import { dependencies } from '@pn/core/dependencies';
import { ApiError } from '@pn/core/errors';
import { handleError } from '@pn/core/errors/handleError';
import { currentUserActions } from '@pn/core/storage';
import { apiUserProvider } from '@pn/services/api/user/apiUserProvider';
import React from 'react';

export async function getCurrentUser(logout: () => void) {
  try {
    currentUserActions().request();

    const user = await apiUserProvider.getCurrentUser();

    currentUserActions().receive(user);
  } catch (error) {
    if (
      error instanceof ApiError &&
      (error.code === 401 || error.code === 403)
    ) {
      logout();
    } else {
      handleError({
        error,
        onError: currentUserActions().error,
      });
    }
  }
}

export function useAutoGetCurrentUser() {
  const { isAuthenticated, logout } = dependencies.useAuthenticationService();

  React.useEffect(() => {
    if (isAuthenticated) getCurrentUser(logout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);
}
